import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Collapsible, CollapsiblePanel, CollapsibleTrigger } from '../../../../web/components-v2/Collapsible';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { ChevronDown } from '../../../../web/components/svgs/icons/ChevronDown';

const { colors, spacing, typography } = THEME;

interface IProps {
	label: string;
	statusChip?: React.ReactNode;
	children: React.ReactNode;
	/**
	 * When false, the section renders with the same header/content layout but
	 * without the collapse affordance — used when there's only one channel and
	 * the toggle adds no value.
	 */
	isCollapsible?: boolean;
}

export function AdsChannelCollapsibleSection({ label, statusChip, children, isCollapsible = true }: IProps) {
	const [isOpen, setIsOpen] = React.useState(true);

	if (!isCollapsible) {
		return (
			<div className={css(styles.container)}>
				<div className={css(styles.trigger, styles.staticHeader)}>
					<h3 className={css(styles.title)}>{label}</h3>
					{statusChip}
				</div>
				<div className={css(styles.content)}>{children}</div>
			</div>
		);
	}

	return (
		<Collapsible open={isOpen} onOpenChange={setIsOpen}>
			<div className={css(styles.container)}>
				<CollapsibleTrigger className={css(styles.trigger)}>
					<h3 className={css(styles.title)}>{label}</h3>
					{statusChip}
					<ChevronDown className={css(styles.chevron, isOpen && styles.chevronOpen)} width={16} height={16} />
				</CollapsibleTrigger>
				<CollapsiblePanel>
					<div className={css(styles.content)}>{children}</div>
				</CollapsiblePanel>
			</div>
		</Collapsible>
	);
}

const styles = StyleSheet.create({
	container: {
		width: '100%',
	},
	trigger: {
		display: 'flex',
		alignItems: 'center',
		gap: spacing.sm,
		width: '100%',
		padding: 0,
		border: 'none',
		backgroundColor: 'transparent',
		cursor: 'pointer',
		textAlign: 'left' as const,
	},
	title: {
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
		color: colors.text.main,
		margin: 0,
	},
	chevron: {
		color: colors.text.main,
		transition: 'transform 250ms ease-out',
		flexShrink: 0,
		transformOrigin: 'center center',
		transform: 'rotate(0deg)',
	},
	chevronOpen: {
		transform: 'rotate(180deg)',
	},
	staticHeader: {
		cursor: 'default',
	},
	content: {
		marginTop: spacing.sm,
	},
});
